"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getPopupSpecs() {
    var popupOptions = {
        width: 800,
        height: 600,
        toolbar: 1,
        resizable: 1
    };
    // IE8 polyfills. Note that outer* ones are not quite right for IE8, but good enough. B147312
    var screenLeft = window.screenLeft || window.screenX;
    var outerWidth = window.outerWidth || window.innerWidth;
    var screenTop = window.screenTop || window.screenY;
    var outerHeight = window.outerHeight || window.innerHeight;
    // Open horizontally centered on current window
    popupOptions.left = screenLeft + (outerWidth - popupOptions.width) / 2;
    // Open vertically centered on current window
    popupOptions.top = screenTop + (outerHeight - popupOptions.height) / 2;
    // if there isn't enough vertical room default back to placing it slightly from the top
    if (popupOptions.top + popupOptions.height > screenTop + outerHeight) {
        popupOptions.top = screenTop + (outerHeight - popupOptions.height) / 8;
    }
    return popupOptions;
}
exports.getPopupSpecs = getPopupSpecs;
function convertSpecsToParams(specs) {
    return Object.keys(specs).map(function (key) { return key + "=" + specs[key]; }).join(',');
}
exports.convertSpecsToParams = convertSpecsToParams;
//# sourceMappingURL=WindowUtils.js.map